export default "__VITE_ASSET__Bellz5fc__"